import React from "react";
import PropTypes from "prop-types";
import { localize } from "redux-i18n";
import uiSchema from "./__ui__/schema";
import { CardContainer, Button, SchemaForm } from "@components";

export class EmployeeIdentity extends React.Component {
  constructor(props) {
    super(props);
    this.state = { renderTime: new Date().getTime() };

    this.reRender = () => {
      this.setState({ renderTime: new Date().getTime() });
    };
  }

  render() {
    return (
      <CardContainer
        className={this.props.className}
        title={this.props.t("PERSONAL_DETAILS")}
        mandatoryTitle={true}
      >
        <SchemaForm
          schema={this.props.schema}
          formData={this.props.settings}
          onSubmit={formData => this.props.onSave({ clientId: this.props.clientId, ...formData })}
          uiSchema={uiSchema}
        >
          <div className="d-flex justify-content-center pt-5">
            <Button className="w-25 mr-5" onClick={this.reRender}>
              {this.props.t("REVERT")}
            </Button>
            <Button materialIcon="save" type="submit" className="w-25">
              {this.props.t("SAVE")}
            </Button>
          </div>
        </SchemaForm>
      </CardContainer>
    );
  }
}

EmployeeIdentity.propTypes = {
  className: PropTypes.string,
  schema: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  clientId: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

EmployeeIdentity.defaultProps = {
  className: "",
};

export default localize()(EmployeeIdentity);
